import { render, staticRenderFns } from "./OmniDropdownCard.vue?vue&type=template&id=3c828fb6&"
import script from "./OmniDropdownCard.vue?vue&type=script&lang=js&"
export * from "./OmniDropdownCard.vue?vue&type=script&lang=js&"
import style0 from "./OmniDropdownCard.vue?vue&type=style&index=0&id=3c828fb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports